module.exports = __webpack_public_path__ + "static/media/united-kingdom.c9fff382.svg";